export default __webpack_public_path__ + "static/media/MyTracker.7c71043b.svg";